import { BrandMark } from "../components/BrandMark";

const INSTAGRAM_URL = "https://www.instagram.com/1976barbecue/";

export function ThanksScreen() {
  return (
    <main className="shell flex flex-col items-center justify-center px-6 py-10 text-center">
      <BrandMark className="mb-10 h-14 w-auto" />

      <div
        className="mb-8 flex h-20 w-20 items-center justify-center rounded-full bg-amber/15"
        aria-hidden="true"
      >
        <svg
          viewBox="0 0 24 24"
          className="h-10 w-10 text-amber"
          fill="none"
          stroke="currentColor"
          strokeWidth={2.5}
          strokeLinecap="round"
          strokeLinejoin="round"
          role="img"
          aria-label="Checkmark"
        >
          <title>Checkmark</title>
          <path d="M5 12.5 10 17.5 19 7" />
        </svg>
      </div>

      <h1 className="text-5xl text-cream">Thanks.</h1>
      <p className="mt-3 max-w-xs text-cream-dim">
        That's the whole lineup. You're entered to win a free meal for two.
      </p>

      <a
        href={INSTAGRAM_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="pill-btn pill-btn-primary mt-10 w-full max-w-xs"
      >
        Follow us on Instagram
      </a>
    </main>
  );
}
